import { css } from "@emotion/react";

export const useStyles = () => css`
  padding: 12px 6px;
  line-height: 1.5;
  font-family: monospace;
  color: #333;
  background: #eee;
`;
